import React from "react";
import GiphyViewer from "../viewer/giphy-viewer";
const Gif = ({ settings, componentData }) => {
  return /* @__PURE__ */ React.createElement(GiphyViewer, { componentData, settings });
};
export {
  Gif
};
//# sourceMappingURL=component.js.map
